import React from 'react'
import useIsMobile from '../../SupportingFiles/MobileProvider';
import IntegrationExcellence from '../../Pages/Desktop/ProductPages/IntegrationExcellence/IntegrationExcellence';
import MIntegrationExcellence from '../../Pages/Mobile/MProductPages/MIntegrationExcellence/MIntegrationExcellence';

const IntegrationExcellenceContainer = () => {
    const isMobile = useIsMobile();
    const journey = [
        {
            head: "Tailored Integration Solutions",
            content: "Personalized solutions crafted to seamlessly align with your unique business processes, ensuring a tailored integration experience that fits your needs."
        },
        {
            head: "API Integration Expertise",
            content: "Leverage our deep expertise in API integration for a smooth, efficient, and perfectly aligned connection with our systems, enhancing your operational efficiency."
        },
        {
            head: "Cutting-Edge Compatibility",
            content: "Insurvent's APIs are crafted to seamlessly integrate with the latest technologies, ensuring compatibility with modern systems in the ever-evolving insurance landscape."
        },
        {
            head: "Legacy System Support",
            content: "Meticulously designed APIs to maintain backward compatibility, facilitating a smooth integration with your existing legacy systems, bridging the gap between old and new technologies."
        },
        {
            head: "Version Control Excellence",
            content: "Our commitment to excellence extends to version control. We diligently manage and update API versions, ensuring you always have access to the latest features, security enhancements, and optimizations."
        },
        {
            head: "24/7 Technical Support",
            content: "Experience peace of mind with our round-the-clock technical support. Our team is dedicated to addressing any integration-related queries or concerns promptly, ensuring minimal downtime for your operations."
        },
    ]
    const why_choose = [
        {
            img: "./images/excellence_img_one.svg",
            title: "Future-Proof Connectivity",
            desc: "Our approach ensures your insurance company's connectivity remains future-proof with forward-compatible APIs supporting your business's growth and evolution.",
        },
        {
            img: "./images/excellence_img_two.svg",
            title: "Collaboration & Communication",
            desc: "Foster improved collaboration and communication between Sales Partners and our integrated systems, ensuring a cohesive and productive partnership for mutual success.",
        },
        {
            img: "./images/excellence_img_three.svg",
            title: "Scalable Solutions",
            desc: "Our integration support is not just for today; it's designed to grow with your business. Whether you're expanding services or onboarding new team members, our solutions scale effortlessly to accommodate your growth.",
        },
        {
            img: "./images/excellence_img_four.svg",
            title: "Stay Ahead of Trends",
            desc: "Keep pace with industry trends through our regular updates and feature enhancements, ensuring that our integrated systems align with the latest technological advancements.",
        },
        {
            img: "./images/excellence_img_five.svg",
            title: "Dedicated Support Team",
            desc: "Partner with our dedicated support team committed to your success. From initial onboarding to ongoing assistance, we're here to ensure that your integration experience is smooth and successful.",
        },
    ];
    const carousel_responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 768 },
            items: 1,
            slidesToSlide: 1,
        },
        mobile: {
            breakpoint: { max: 767, min: 200 },
            items: 1,
            slidesToSlide: 1,
        },
    };


    return isMobile ? (
        <MIntegrationExcellence
            journey={journey}
            why_choose={why_choose}
            carousel_responsive={carousel_responsive}
        />
    ) : (
        <IntegrationExcellence
            journey={journey}
            why_choose={why_choose}
            carousel_responsive={carousel_responsive}
        />
    )
}

export default IntegrationExcellenceContainer